// @core/api/endpoints/document/get_document_content.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetDocumentContentResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get document content
 * Returns document content as a tree of blocks. Supports pagination for large documents and configurable depth for lazy loading of nested content.
 */
export async function GetDocumentContent(
  document_id: string,
  options?: RequestOptions
): Promise<GetDocumentContentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/blocks`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.get<GetDocumentContentResponse>(requestPath, { ...requestOptions });
}
